module.exports = __webpack_public_path__ + "img/internet.c2acb322.svg";